import Vue from 'vue';
import VueX from 'vuex';
import VueXPersistence from 'vuex-persist';
import { subscribe } from '../util/pubsub';
import Basket from './Basket.vue';
import MiniBasket from './MiniBasket.vue';
import { get, set } from 'lodash';

Vue.use(VueX);

const defaultState = () => ({
    items: [],
    has_delivery: false,
    prom_code: "",
    mondial_relay_AP: '',
    coords_billing: {
        country: "France",
        first_name: "",
        last_name: "",
        email: "",
        email_2: "",
        phone: "",
        address: "",
        address_comp: "",
        post_code: "",
        city: "",
    },
    coords_delivery: {
        country: "France",
        first_name: "",
        last_name: "",
        phone: "",
        address: "",
        address_comp: "",
        post_code: "",
        city: "",
    },
    shipping_boomerang: false,
    shipping: "standard",
});
const store = new VueX.Store({
    state: {
        foo: 'bar',
        ...defaultState(),
    },
    mutations: {
        reset(state) {
            const n = defaultState();
            for (let key in n) {
                state[key] = n[key];
            }
        },
        foo(state, p) {
            state.foo = p || 'baz';
        },
        add_item(state, item) {
            const c = state.items.find(a => a.type === item.type && a.id === item.id);
            if (c) {
                c.qty += item.qty;
            } else {
                state.items.push(item);
            }
        },
        remove_item(state, index) {
            state.items = state.items.filter((_, i) => i !== index);
        },
        dec_qty(state, index) {
            const item = state.items[index];
            if (item.qty < 1) return;
            item.qty = item.qty - 1;
            if (item.qty === 0) {
                state.items = state.items.filter((a, i) => i !== index);
            }
        },
        inc_qty(state, index) {
            const item = state.items[index];
            if (item.qty > 9) return;
            item.qty = item.qty + 1;
        },
        dec_qty_m(state, index) {
            const item = state.items[index];
            if (item.qty <= 1) return;
            let v;
            if (item.qty === 12) v = 6;
            else if (item.qty === 6) v = 3;
            else if (item.qty === 3) v = 1;
            item.qty = v;
        },
        inc_qty_m(state, index) {
            const item = state.items[index];
            if (item.qty >= 12) return;
            let v;
            if (item.qty === 1) v = 3;
            else if (item.qty === 3) v = 6;
            else if (item.qty === 6) v = 12;
            item.qty = v;
        },
        update_qty(state, { index, qty }) {
            state.items = state.items.map((item, i) => i === index ? { ...item, qty } : item);
        },
        set(state, args) {
            const path = args.slice(0, args.length - 1);
            const value = args.slice(args.length - 1, args.length)[0];
            set(state, path, value);
        },
        setItems(state, items) {
            state.items = items;
        }
    },
    plugins: [
        new VueXPersistence({
            key: 'techne-store-nb',
            storage: window.localStorage,
            reducer: (state) => ({ items: state.items }),
        }).plugin,
    ],
});

const serialize = cart => {
  const current_cart = cart.slice(0); // on copie le cart courant
  current_cart.sort((a, b) => a.id < b.id ? -1 : 1); // on trie par ID
  return current_cart.map(a => `${a.id}-${a.qty}`).join(","); // on le serialize selon un format prévisible
};

setInterval(() => {
    let cart;
    try {
        cart = JSON.parse(window.localStorage.getItem('techne-store-nb')).items;
    } catch (e) {
        return;
    }
  const current_cart = store.state.items;
  if (serialize(cart) !== serialize(current_cart)) {
    store.commit('setItems', cart);
  }
}, 500);

subscribe('ADD_TO_BASKET', (book) => {
    store.commit('add_item', book);
});

subscribe('RESET_BASKET', () => {
    store.commit('reset');
});

const basket = function () {
    if (document.getElementById('basket-app')) {
        const $vm = new Vue({ el: '#basket-app', render: h => h(Basket), store });
    }
    if (document.getElementById('mini-basket')) {
        const $vm2 = new Vue({ el: '#mini-basket', render: h => h(MiniBasket), store })
    }
    if (document.getElementById('micro-basket-a')) {
        const $vm2 = new Vue({ el: '#micro-basket-a', render: h => h(MiniBasket), store })
    }
    if (document.getElementById('micro-basket-b')) {
        const $vm2 = new Vue({ el: '#micro-basket-b', render: h => h(MiniBasket), store })
    }
};
export default basket;
basket();
